import { Injectable } from '@nestjs/common';
import { IndentRepository } from './dto/indent-repository';
import { CommonResponseModel, IndentReq, IndentFabricModel, IndentModel, IndentTrimsModel, IndentRequestDto, indentIdReq, BuyerRefNoRequest, ColourDto, UploadResponse, indentId, CustomerOrderStatusEnum, PurchaseOrderStatus, userNamedto } from '@project-management-system/shared-models';
import { Indent } from './indent-entity';
import { IndentDto } from './dto/indent-dto';
import { IndentAdapter } from './dto/indent-adapter';
import { ErrorResponse } from 'packages/libs/backend-utils/src/models/global-res-object';
import { DataSource, Repository } from 'typeorm';
import { FabricIndentRepository } from './dto/fabric-indent-repository';
import { TrimIndentRepository } from './dto/trim-indent-repository';
import { UomService } from '@project-management-system/shared-services';
import { Colour } from '../colours/colour.entity';
import { ColourService } from '../colours/colour.service';
import { ColourDTO } from '../colours/dto/colour-dto';

import { GenericTransactionManager } from '../../typeorm-transactions';
import { IndentFabricEntity } from './indent-fabric-entity';
import { IndentTrimsEntity } from './indent-trims-entity';
import { PurchaseOrderRepository } from '../purchase-order/repo/purchase-order-repository';
import { EmployeeDetailsRepo } from '../employee-details/dto/employee-detail-repository';
import { EmployeeBuyerMappingService } from '../employee-buyer-mapping/employee-buyer-mapping.service';
import axios from 'axios';
import * as nodemailer from 'nodemailer';
import { BuyersService } from '../buyers/buyers.service';
import { Cron } from '@nestjs/schedule';
import { request } from 'node:http';
import { IndentFabricFilesEntity } from './indent-fabric-files-enity';
import { IndentTrimsFilesEntity } from './indent-trim-files-entity';

@Injectable()

export class IndentService {
          private transporter: nodemailer.Transporter;
    
    constructor(
        
        private indentRepo: IndentRepository,
        private purchaseOrderRepository: PurchaseOrderRepository,
        private indentFabricRepo: FabricIndentRepository,
        private indentTrimRepo: TrimIndentRepository,
        private colorService:ColourService,
        // private ColourRepository: Repository<Colour>,
        private uomService: UomService,
        private indentAdapter: IndentAdapter,
        private readonly dataSource: DataSource,
        private employeeDetailsRepo:EmployeeDetailsRepo,
        private employeeBuyerMappingService:EmployeeBuyerMappingService,
        private buyerService:BuyersService,

    ) { 
         this.transporter = nodemailer.createTransport({
                            service: 'gmail',
                            auth: {
                                user: 'helpdesk@schemaxtech.com',
                                pass: 'jend gpnz htps asjn',         
                                             },
                        });
    }

    async creteIndent(req: IndentDto, isUpdate: boolean): Promise<CommonResponseModel> {
        try {
            for(const rec of req.indentFabricDetails){
                if(rec.newColor){

                    const colorobj = new Colour()
                    const req = new ColourDTO()
                    req.colourId = null
                    req.colour = rec.newColor
                    req.createdUser = 'Admin';
                    const saveColor = await this.colorService.createColour(req,false)
                    if(saveColor.status){
                        rec.color = saveColor.data[0].colourId
                    }else{
                        let msg = 'Something went wrong in adding new colour';
                        if(saveColor.errorCode == 11104){
                            msg = 'Added new Color already existed in the list';
                        }
                        return new CommonResponseModel(false,0,msg)
                    }
                  }
            }

            const slNo = await this.indentRepo.count()
            // console.log(slNo);
            const today = new Date();
            const CurrentYear = today.getFullYear();
            const CurrentMonth = today.getMonth();
            let fromDate = 0;
            let toDate = 0;
            let totalIndents
            if (CurrentMonth < 4) {
                fromDate = (CurrentYear-1);
                toDate = (CurrentYear);
            } else {
                fromDate = (CurrentYear);
                toDate = (CurrentYear + 1);
            }
            totalIndents = slNo + 1;
            let refNo = totalIndents + "";
            while (refNo.length < 4) refNo = "0" + refNo;
            const indentnum = "IND" + "/"+(fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2))+ "/" + refNo
            req.requestNo = indentnum;
            //  console.log(req);
            const convertedindentEntity: Indent = this.indentAdapter.convertDtoToEntity(req, isUpdate);
            // console.log(convertedindentEntity)
            const savedindentEntity: Indent = await this.indentRepo.save(convertedindentEntity);
            const savedindentDto: IndentDto = this.indentAdapter.convertEntityToDto(savedindentEntity);

            if (savedindentDto) {
                // console.log(req.marketingUser,'----------')
       
       
            const response = new CommonResponseModel(true, 1, isUpdate ? 'Indent Updated Successfully' : 'Indent Created Successfully', savedindentDto);
                return response;
            } else {
                throw new ErrorResponse(11106, 'Indent saved but issue while transforming into DTO');
            }
        } catch (error) {
            return error;
        }
    }

   
    async indentFabricUpload(files: any[], fabIds: any): Promise<UploadResponse> {
        const manager = new GenericTransactionManager(this.dataSource);
        // console.log("🟢 Received files in service:", files);
        // console.log("🟢 Received fabIds in service:", fabIds);
    
        try {
            await manager.startTransaction();
            const fabId = fabIds[0]?.ifabricId; // Use the first (and only) fabric ID
    
            if (!fabId) {
                return new UploadResponse(false, 400, "Fabric ID is missing", []);
            }
    
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
    
    
                if (!file) {
                    continue;
                }
    
                const entity = new IndentFabricFilesEntity();
                entity.fileName = file.filename;
                entity.filePath = file.path;
    
                const parentEntity = new IndentFabricEntity();
                parentEntity.ifabricId = fabId; 
                entity.indentInfo = parentEntity;
    
                const savedEntity = await manager.getRepository(IndentFabricFilesEntity).save(entity);
                // console.log("✅ Saved to Database:", savedEntity);
            }
    
            await manager.completeTransaction();
            return new UploadResponse(true, 11, 'Uploaded successfully', files);
    
        } catch (error) {
            await manager.releaseTransaction();
            // console.error("❌ Error during file upload:", error);
            return new UploadResponse(false, 11, 'Upload failed due to an error', []);
        }
    }


      async indentTrimUpload(files: any[], fabIds: any): Promise<UploadResponse> {
        // console.log(filePath);
        // console.log(data);
        // console.log(JSON.parse(data));
      console.log("🟢 Received files in service:", files);
        console.log("🟢 Received fabIds in service:", fabIds);
        const manager = new GenericTransactionManager(this.dataSource)
        try {
          await manager.startTransaction();
          const fabId = fabIds[0]?.itrimsId;
          if(!fabId){
            return new UploadResponse(false, 400, "Fabric ID is missing", [])
          }
          for ( let i= 0; i<files.length; i++){
            const file =files[i];
            if(!file){
                continue;
            }
            const entity = new IndentTrimsFilesEntity()
            entity.fileName = file.filename;
            entity.filePath = file.path;
            const parentEntity = new IndentTrimsEntity();
            parentEntity.itrimsId = fabId; 
            entity.indentInfo = parentEntity;

            const savedEntity=await manager.getRepository(IndentTrimsFilesEntity).save(entity);
                            console.log("✅ Saved to Database:", savedEntity);

          }
          await manager.completeTransaction();
          return new UploadResponse(true, 11, 'Uploaded successfully', files);

        }catch (error) {
          await manager.releaseTransaction();
                      console.error("❌ Error during file upload:", error);

        //   console.log(error);
        }
      }

    async getAllIndentData(req?: any): Promise<CommonResponseModel> {
       

        console.log("******************")
        console.log(req)

        let getBuyerByIds
        if(req.extRefNumber != undefined && req.extRefNumber != 'admin'){
            let employeId = await this.employeeDetailsRepo.findOne({where:{emial:req.email}});
            console.log(employeId)
            getBuyerByIds = await this.employeeBuyerMappingService.getMappedBuyers({employeeId:employeId?.employeeId});
            console.log(getBuyerByIds)
        }
        console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&")
        console.log("******************")
        const indentData = await this.indentRepo.getAllIndentData(req.extRefNumber,getBuyerByIds != undefined ?getBuyerByIds?.data.buyerIds:"");
        // console.log(indentData,'indentdataaa')
        // if (req.requestNo) {
        //     indentData = indentData + ' and ,it.request_no = "' + req.requestNo + '"'
        //   }
        //   if (req.style) {
        //     indentData = indentData + ' and ,st.style = "' + req.style + '"'
        //   }
        //   if (req.status) {
        //     indentData = indentData + ' and ,it.status = "' + req.status + '"'
        //   }
        //   indentData = indentData + ' group by it.indent_id '
      
        const indentModel = []
        // const uomInfo = await this.uomService.getAllActiveUoms();
        //   const uomNameMap = new Map<number, string>();
        //   uomInfo.data.forEach(uom => uomNameMap.set(uom.uomId, uom.uom));
        for (const data of indentData) {
            const fabricModel = [];
            const trimModel = [];
            if(req.tab === 'both' ){
                const fabricIndentData = await this.indentFabricRepo.getFabricIndentData(data.indent_id);
                for (const fabric of fabricIndentData) {
                    // console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
                    // console.log(fabric.hsnCode)
                    fabricModel.push(new IndentFabricModel(fabric.ifabric_id, fabric.content,
                        fabric.fabric_type_name, fabric.fabric_weave_name, fabric.weight, fabric.width, fabric.yarn_count, fabric.unit, fabric.construction, fabric.finish, fabric.shrinkage, fabric.m3_fabric_code,fabric.colour,
                        fabric.pch, fabric.moq, fabric.moqUnit, fabric.moq_price, fabric.moqPriceUnit, fabric.season, fabric.vendor_name,
                        fabric.buyer, fabric.grn_date, fabric.xlNo, fabric.quantity, fabric.quantityUnit, fabric.status,fabric.indentId,fabric.materialType,fabric.description,fabric.buyerId,data.styleId,(Number(fabric.quantity) - Number(fabric.poQty)) > 0?true:false,fabric.indentCode,fabric.description,fabric.colour,fabric.quantity,fabric.poQuantity,fabric.quantityUnit,fabric.colorId,fabric.ifabric_id,fabric.description,fabric.quantity_unit,fabric.poQty,fabric.item_code,fabric.toBeProcured,fabric.hsnCode,fabric.fileName,fabric.fileName,fabric.orderType,fabric.minMoqQuantity,fabric.maxMoqQuantity,fabric.tolerance,data.isValid,fabric.shadeNo,fabric.description,fabric.quantityUnit,fabric.tax))
                       
                }
                const trimIndentData = await this.indentTrimRepo.getTrimIndentData(data.indent_id);
                for (const trim of trimIndentData) {
                    //trim params
                    // console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
                    // console.log(trim.hsnCode)
                    const trueValues = Object.keys(trim)
                    .filter(key => ["structure", "category", "content", "type", "finish", "hole", "quality", "thickness", "variety", "uom", "color", "logo", "part"].includes(key) && trim[key] === 1)
                    .map(key => key.toUpperCase());
    
                    const concatenatedValues = trueValues.join('/');
                    const label = trueValues.length > 0 ? "BUYER/TRIM TYPE/TRIM CATEGORY/":""
                    const trimParams = label + concatenatedValues
                    

                    trimModel.push(new IndentTrimsModel(trim.itrims_id, trim.trimType, trim.item_code, trim.size, trim.color,
                        trim.quantity, trim.trim_code, trim.description,
                        trim.remarks, trim.quantity,trim.quantityUnit, trim.status,trim.indentId,trim.materialType,trim.buyerName,trim.buyerId,trim.quantityUnitId,trim.styleId,(Number(trim.quantity) - Number(trim.poQty)) > 0?true:false,trim.itrims_id,trim.description,trim.indentCode,trim.poQty,trim.quantity,trim.poQuantity,trimParams,trim.toBeProcured,trim.trimUomId,trim.trimUomName,trim.hsnCode,trim.filePath,trim.fileName,data.isValid,trim.trimCategoryName,trim.trimCategory,trim.sizeId,trim.colorId,trim.tax))
                    // console.log(trimModel);

                }
                indentModel.push(new IndentModel(data.indent_id, data.request_no, data.indent_date, data.expected_date, data.status, fabricModel, trimModel, data.style, data.description, data.created_at,data.buyerName,data.extRefNo,data.styleId,data.buyerId,data.isValid,data.plantId,data.plantName,data.formatted_datetime))
            }
            else if(req.tab === "FABRIC" ){
                const fabricIndentData = await this.indentFabricRepo.getFabricIndentData(data.indent_id);
                console.log(fabricIndentData,"dataaaaaaaaaaaa");
                
                for (const fabric of fabricIndentData) {
                    console.log();
                    
                    fabricModel.push(new IndentFabricModel(fabric.ifabric_id, fabric.content,
                        fabric.fabric_type_name, fabric.fabric_weave_name, fabric.weight, fabric.width, fabric.yarn_count, fabric.unit, fabric.construction, fabric.finish, fabric.shrinkage, fabric.m3_fabric_code,fabric.colour,
                        fabric.pch, fabric.moq, fabric.moqUnit, fabric.moq_price, fabric.moqPriceUnit, fabric.season, fabric.vendor_name,
                        fabric.buyer, fabric.grn_date, fabric.xlNo, fabric.quantity, fabric.quantityUnit, fabric.status,fabric.indentId,fabric.materialType,fabric.description,fabric.buyerId,data.styleId,(Number(fabric.quantity) - Number(fabric.poQty)) > 0?true:false,fabric.indentCode,fabric.description,fabric.colour,fabric.quantity,fabric.poQuantity,fabric.quantityUnit,fabric.colorId,fabric.ifabric_id,fabric.description,fabric.quantity_unit,fabric.poQty,fabric.item_code,fabric.toBeProcured,fabric.hsnCode,fabric.filePath,fabric.fileName,fabric.orderType,fabric.minMoqQuantity,fabric.maxMoqQuantity,fabric.tolerance,data.isValid,fabric.shadeNo,fabric.description,fabric.quantityUnit,fabric.tax))
                        console.log(fabric,"taxxxxxxxxxxxxxxxxxxxxx")
                }
                console.log(fabricModel,"**********************************")
                console.log(fabricModel.length)
                if(fabricModel.length > 0){
                    indentModel.push(new IndentModel(data.indent_id, data.request_no, data.indent_date, data.expected_date, data.status, fabricModel, [], data.style, data.description, data.created_at,data.buyerName,data.extRefNo,data.styleId,data.buyerId,data.isValid,data.plantId,data.plantName,data.formatted_datetime))
                }
            }
            else if(req.tab === 'Trim'){
                const trimIndentData = await this.indentTrimRepo.getTrimIndentData(data.indent_id);
                for (const trim of trimIndentData) {
                    //trim params
                    const trueValues = Object.keys(trim)
                    .filter(key => ["structure", "category", "content", "type", "finish", "hole", "quality", "thickness", "variety", "uom", "color", "logo", "part"].includes(key) && trim[key] === 1)
                    .map(key => key.toUpperCase());
    
                    const concatenatedValues = trueValues.join('/');
                    const label = trueValues.length > 0 ? "BUYER/TRIM TYPE/TRIM CATEGORY/":""
                    const trimParams = label + concatenatedValues
                    trimModel.push(new IndentTrimsModel(trim.itrims_id, trim.trimType, trim.item_code, trim.size, trim.color,
                        trim.quantity, trim.trim_code,trim.description,
                        trim.remarks, trim.quantity,trim.quantityUnit, trim.status,trim.indentId,trim.materialType,trim.buyerName,trim.buyerId,trim.quantityUnitId,trim.styleId,(Number(trim.quantity) - Number(trim.poQty)) > 0?true:false,trim.itrims_id,trim.description,trim.indentCode,trim.poQty,trim.quantity,trim.poQuantity,trimParams,trim.toBeProcured,trim.trimUomId,trim.trimUomName,trim.hsnCode,trim.filePath,trim.fileName,trim.isValid,trim.trimCategoryName,trim.trimCategory,trim.sizeId,trim.colorId,trim.tax))
                    // console.log(trimModel);

                }
                if(trimModel.length>0){
                indentModel.push(new IndentModel(data.indent_id, data.request_no, data.indent_date, data.expected_date, data.status, [], trimModel, data.style, data.description, data.created_at,data.buyerName,data.extRefNo,data.styleId,data.buyerId,data.isValid,data.plantId,data.plantName,data.formatted_datetime))
                }
            }

          
        }
        
        return new CommonResponseModel(true, 1235, 'Data retrieved Successfully', indentModel);
    }

    async getIndentnumbers(req?:BuyerRefNoRequest): Promise<CommonResponseModel> {
        let buyerId
        if(req?.buyerRefNo){
            const buyerdata = `select buyer_id from buyers where external_ref_number = '${req.buyerRefNo}'`;
            const res = await this.dataSource.query(buyerdata)
            buyerId = res[0].buyer_id
        }
        let data = `select indent_id as indentId ,request_no as indentCode from indent`
        if(req.buyerRefNo){
            data = data+` where buyer_id = ${buyerId}`
        }
        // console.log('dataaaaanyuuu',data)
        const result = await this.indentRepo.query(data)
        if (result) {
            return new CommonResponseModel(true, 1, 'data retived sucessfully', result)
        } else {
            return new CommonResponseModel(false, 0, 'no data found', [])
        }
    }

   
    async getAllIndentItemDetailsAgainstIndent(req: indentIdReq): Promise<CommonResponseModel> {
        // console.log(req)
        // const data = 'SELECT "" as poQuantity,yarn_unit as yarnUnit,ifb.ifabric_id as indentFabricId,ifb.indent_id as indentid,ft.fabric_type_id as fabric_type_id,m3_code as m3FabricCode,fabric_weave_name as fabricTypeName,p.profit_control_head AS pch,color AS colorName,fabric_weave_name AS weaveName,fabric_type_name AS fabricTypeName,content,ifb.fabric_type AS fabricTypeId,weave_id AS weaveId,weight,width,yarn_count AS yarnCount,construction,finish,shrinkage,m3_fabric_code,color AS colourId,pch,moq,moq_unit,quantity AS indentQuantity,ifb.indent_id AS indentId FROM indent_fabric ifb LEFT JOIN indent i ON ifb.indent_id=i.indent_id  LEFT JOIN fabric_type ft ON ft.fabric_type_id=ifb.fabric_type LEFT JOIN fabric_weave fw ON fw.fabric_weave_id=ifb.weave_id  LEFT JOIN colour c ON c.colour_id=ifb.color LEFT JOIN profit_control_head p ON p.profit_control_head_id=ifb.pch left join m3_masters ms on ms.m3_code=ifb.m3_fabric_code where ifb.indent_id in ('+req.indentId+') '
        const data = '  SELECT i.request_no AS indentCode,"" AS poQuantity,ifb.ifabric_id AS indentFabricId,ifb.indent_id AS indentid,item_code AS itemCode,colour AS colorName, ifb.m3_fabric_code m3FabricCode,color AS colourId,quantity AS indentQuantity,ifb.quantity_unit as quantityUomId,u.uom as quantityUom,ifb.indent_id AS indentId,i.buyer_id as buyerId,i.style  FROM indent_fabric ifb LEFT JOIN indent i ON ifb.indent_id=i.indent_id LEFT JOIN colour c ON c.colour_id=ifb.color LEFT JOIN m3_items ms ON ms.m3_items_Id=ifb.m3_fabric_code LEFT JOIN uom u ON u.id=ifb.quantity_unit WHERE ifb.indent_id IN (' + req.indentId + ')'
        const result = await this.indentRepo.query(data)
        if (result) {
            return new CommonResponseModel(true, 1, 'data retived sucessfully', result)
        } else {
            return new CommonResponseModel(false, 0, 'no data found', [])
        }
    }

    async getAllIndentTrimDetailsAgainstIndent(req: indentIdReq): Promise<CommonResponseModel> {
        // console.log(req)
        // const data = 'SELECT "" as poQuantity,item_code as trimCodeName,it.trim_type as productGroupId,trim_code as trimId, pg.product_group as trimType,c.colour AS colourName,item_code AS trimCodeName,product_group AS productGroup,itrims_id AS indentTrmId,trim_code AS trimId ,size AS sizeId,color AS colourId, quantity as indentQuantity,quantity_unit AS indentQuantityUnit,m3_trim_code AS m3TrimCode FROM indent_trims it LEFT JOIN indent i ON it.indent_id=i.indent_id LEFT JOIN product_group pg ON pg.product_group_id=it.trim_type LEFT JOIN rm_items ri ON ri.rm_item_id=it.trim_code LEFT JOIN colour c ON c.colour_id=it.color where it.indent_id in(' + req.indentId + ') '
        const data ='SELECT it.indent_id as indentId,m3_trim_Id AS m3TrimCode,request_no AS indentCode,"" AS poQuantity,ms.trim_type AS trimtype,ms.trim_code AS m3TrimCodeName,ms.trim_mapping_id as trimMappingId,it.trim_type AS productGroupId,it.trim_code AS trimId, itrims_id AS indentTrmId, it.trim_code AS trimId ,quantity AS indentQuantity, it.quantity_unit AS quantityUnitId, u.uom AS quantityUnit, tpm.structure, tpm.category, tpm.content, tpm.type, tpm.finish, tpm.hole, tpm.quality, tpm.thickness, tpm.variety, tpm.uom, tpm.color, tpm.logo, tpm.part,i.style as styleId FROM indent_trims it LEFT JOIN indent i ON it.indent_id=i.indent_id  LEFT JOIN m3_trims ms ON ms.m3_trim_Id=it.trim_code left join uom u on u.id = it.quantity_unit LEFT JOIN trim_params_mapping tpm ON tpm.trim_mapping_id = ms.trim_mapping_id WHERE it.indent_id in(' + req.indentId + ') '
        const result = await this.indentRepo.query(data)
        if (result.length > 0) {
            const modifiedRes = result.map(item => {
                const trueValues = Object.keys(item)
                .filter(key => ["structure", "category", "content", "type", "finish", "hole", "quality", "thickness", "variety", "uom", "color", "logo", "part"].includes(key) && item[key] === 1)
                .map(key => key.toUpperCase());

                const concatenatedValues = trueValues.join('/');
                const label = trueValues.length > 0 ? "BUYER/TRIM TYPE/TRIM CATEGORY/":""

                const trimParams = label + concatenatedValues
                return { ...item, trimParams };
            });

            return new CommonResponseModel(true, 1, "Stock retrieved successfully", modifiedRes);
        } else {
            return new CommonResponseModel(false, 0, 'no data found', [])
        }
    }

    async getIndentData(req: IndentRequestDto): Promise<CommonResponseModel> {
        const data = await this.indentRepo.getIndentData(req);
        if (data.length > 0) {
            const groupedData = data.reduce((result, item) => {
                const requestNo = item?.requestNo;
                const style = item.style;
                const indentDate = item.indentDate;
                const expectedDate = item.expectedDate;
                 const status = item.STATUS

                if (!result[requestNo]) {
                    result[requestNo] = {
                        requestNo: requestNo,
                        style: style,
                        indentDate: indentDate,
                        expectedDate: expectedDate,
                        status: status,
                        plantName:item.plantName,

                        i_items: [],
                    };
                }
                if(req.tab === 'both'){
                    if(item.fabricId !== null){
                    result[requestNo].i_items.push({
                        requestNo: item?.requestNo,
                        fabricId: item.fabricId,
                        materialtype: 'Fabric',
                        quantity: item.fbquantity,
                        color: item.color,
                        status: item.STATUS,
                        m3Code: item.m3FabricCode,
                        uom:item.fabUom,

                    }); 
                }
                    if(item.trimType !== null){
                    result[requestNo].i_items.push({
                        requestNo: item?.requestNo,
                        itrims_id: item.itrims_id,
                        materialtype: item.trimType,
                        trimCode: item.trimCode,
                        quantity: item.quantity,
                        color: item.color,
                        m3Code: item.m3TrimCode,
                       status: item.STATUS,
                       uom:item.trimUom,

                    }) 
                }
                }
                if(req.tab!=undefined && req.tab === 'FABRIC' && item.fabricId !== null){
                result[requestNo].i_items.push({
                    requestNo: item?.requestNo,
                    fabricId: item.fabricId,
                    materialtype: 'Fabric',
                    quantity: item.fbquantity,
                    color: item.color,
                    status: item.STATUS,
                    m3Code: item.m3FabricCode,
                    uom:item.fabUom,


                });
            }
                if(req.tab!=undefined && req.tab === 'TRIM' && item.trimType !== null){

                result[requestNo].i_items.push({
                    requestNo: item?.requestNo,
                    itrims_id: item.itrims_id,
                    materialtype: item.trimType,
                    trimCode: item.trimCode,
                    quantity: item.quantity,
                    color: item.color,
                    m3Code: item.m3TrimCode,
                   status: item.STATUS,
                   uom:item.trimUom,

                })
            }


                return result;
            }, {});

            return new CommonResponseModel(true, 1, 'Data retrieved successfully', Object.values(groupedData));
        } return new CommonResponseModel(false, 0, 'No data found', []);
    } 

    async getIndentDropDown(req: IndentRequestDto): Promise<CommonResponseModel> {
        const data = await this.indentRepo.getIndentDropDown()
        if (data.length) {
            return new CommonResponseModel(true, 1, 'Inventory data Retrived Sucessfully', data)
        } else {
            return new CommonResponseModel(false, 6546, 'Inventory data Not Found', data)

        }

    }
    
    // async getIndentDate(req:IndentRequestDto): Promise<CommonResponseModel> {
    //     const data = await this.indentRepo.getIndentDropDown()
    //     if (data.length) {
    //         return new CommonResponseModel(true, 1, 'Inventory data Retrived Sucessfully', data)
    //     } else {
    //         return new CommonResponseModel(false, 6546, 'Inventory data Not Found', data)

    //     }

    // }

    async updateIsValid(req:userNamedto):Promise<CommonResponseModel>{
        try{
            const update = await this.indentRepo.update({indentId:req.indentId},{isValid:'YES'})

            if(update.affected){

                    const get= await this.indentRepo.find({where:{indentId:req.indentId}})
              
            }
                return new CommonResponseModel(true,1,'Indent Is Validated Sucessfully')
            

        }catch(err){
            throw err
        }
    }


    async closeIndent(req:indentId):Promise<CommonResponseModel>{
        try{
            // console.log(req);
            const getIndent = await this.indentRepo.findOne({relations:["iFabricInfo","iTrimsInfo"],where:{indentId:req.indentId}});
            // console.log(getIndent);
            // console.log(getIndent.iFabricInfo);
            // console.log(getIndent.iTrimsInfo);
            let fabIds: number[] = [];
            let trimsIds: number[] = [];
            
            for (const fab of getIndent.iFabricInfo) {
                fabIds.push(fab.ifabricId);
            }
            for (const tri of getIndent.iTrimsInfo) {
                trimsIds.push(tri.itrimsId);
            }
            
            let fabIdsString = fabIds.join("','");
            let trimsIdsString = trimsIds.join("','");
            
            fabIdsString = `'${fabIdsString}'`;
            trimsIdsString = `'${trimsIdsString}'`;
            
            // console.log(fabIdsString); // 'id1','id2','id3'
            // console.log(trimsIdsString); // 'id1','id2','id3'

            const checkFabPoExist = 'SELECT * from purchae_order_items where item_type = "FABRIC" and indent_item_id in ('+fabIdsString+')'
            const fabResult = await this.indentRepo.query(checkFabPoExist)

            const checkTrimPoExist = 'SELECT * from purchae_order_items where item_type != "FABRIC" and indent_item_id in ('+trimsIdsString+')'
            const trimResult = await this.indentRepo.query(checkTrimPoExist)

            // console.log(fabResult);
            // console.log(trimResult);

            const update = await this.indentRepo.update({indentId:req.indentId},{status:CustomerOrderStatusEnum.CLOSED})
            if(update.affected){
                if(fabResult.length > 0 || trimResult.length > 0){
                    const closePO = await this.purchaseOrderRepository.update({purchaseOrderId:fabResult[0].purchase_order_id},{status:PurchaseOrderStatus.CLOSED})
                    // if(closePO.affected){
                        return new CommonResponseModel(true,1,'Indent Is Closed Sucessfully')
                    // }else{
                    //     return new CommonResponseModel(false,0,'Something Went Wrong')
                    // }
                }
                else{
                    return new CommonResponseModel(true,1,'Indent Is Closed Sucessfully')
                }
            }else{
                return new CommonResponseModel(false,0,'Something Went Wrong')
            }

        }catch(err){
            throw err
        }
    }
    async getUnits(): Promise<CommonResponseModel> {
        const data = await this.indentRepo.getUnits()
        if (data.length) {
            return new CommonResponseModel(true, 1, 'Inventory data Retrived Sucessfully', data)
        } else {
            return new CommonResponseModel(false, 6546, 'Inventory data Not Found', data)

        }

    }

    async getSamplingDataApi(): Promise<CommonResponseModel> {
        try {
         
          const payload = {
            poNumber: "",
            movexPo: '',
            indentNo: 'null',
            STATUS: "",
            item_description: ''
          };
      
      
          const response = await axios.post(
            'http://172.20.50.183:4016/api/sample-bot/samplingDataApi',
            payload
          );
        
      
          return {
            status: true,
            errorCode: 1,
            internalMessage: 'Data fetched successfully',
            data: response.data, 
          };
        } catch (error) {
          console.error('Error fetching sampling data:', error);
          throw new Error('Unable to fetch data from the sampling API');
        }
      }
 

  async getMovexPoReferenceApi(): Promise<CommonResponseModel> {
    try {
     
      const payload = {
        poNumber: "",
        movexPo: '',
        STATUS: "",
        item_description: ''
      };
  
  
      const response = await axios.post(
        'http://172.20.50.183:4016/api/sample-bot/allSamplingDataApi',
        payload
      );
    
  
      return {
        status: true,
        errorCode: 1,
        internalMessage: 'Data fetched successfully',
        data: response.data, 
      };
    } catch (error) {
      console.error('Error fetching sampling data:', error);
      throw new Error('Unable to fetch data from the sampling API');
    }

    
  }

//   async PdfUpload(pdffilePath:any,data:any): Promise<CommonResponseModel> {
//     const manager = new GenericTransactionManager(this.dataSource)

//     try {
//         let flag = true;

//       await manager.startTransaction();

//       const parsedData = JSON.parse(data);
//       for (const [index, value] of parsedData.entries()) {
//         const fullPath = `upload-files/${pdffilePath[index]}`;  

//         const updateFilePath = await manager.getRepository(IndentFabricEntity).update(
//             { ifabricId: value.ifabricId },
//             { 
//                 pdffileName: pdffilePath[index], 
//                 pdffilePath: fullPath  
//             }
//         );
//         if (!(updateFilePath.affected > 0)) {
//             flag = false;
//         }
//     }
//       if (flag) {
//         await manager.completeTransaction();
//         return new UploadResponse(true, 11, 'uploaded successfully', pdffilePath);
//       }
//       else {
//         await manager.releaseTransaction();
//         return new UploadResponse(false, 11, 'uploaded failed', pdffilePath);
//       }
//     }catch (error) {
//       await manager.releaseTransaction();
//     //   console.log(error);
//     }
//} 


async PdfUpload(filePaths: any[], fabIds: string): Promise<UploadResponse> {
    // console.log('Received file paths:', filePaths);
    // console.log('Received fabIds:', fabIds);

    let parsedData;
    try {
        parsedData = JSON.parse(fabIds);
        console.log('Parsed Data:', parsedData);
    } catch (error) {
        console.error('Error parsing fabIds:', error);
        return new UploadResponse(false, 11, 'Invalid fabIds format', []);
    }

    const manager = new GenericTransactionManager(this.dataSource);
    try {
        await manager.startTransaction();
        let updateSuccess = true;

        for (const [index, value] of parsedData.entries()) {
            const fabricId = value.ifabricId;
            const fileRecord = filePaths[index];

            if (!fabricId || !fileRecord) {
                // console.error(`Missing fabricId or file at index ${index}`);
                updateSuccess = false;
                continue;
            }

            // console.log(`Updating fabricId: ${fabricId} with file: ${fileRecord.filename}`);

            // Verify if the record exists
            const existingRecord = await manager.getRepository(IndentFabricEntity).findOne({
                where: { ifabricId: fabricId },
            });

            if (!existingRecord) {
                // console.error(`No record found for ifabricId: ${fabricId}`);
                updateSuccess = false;
                continue;
            }

            const updateFilePath = await manager.getRepository(IndentFabricEntity)
                .createQueryBuilder()
                .update(IndentFabricEntity)
                .set({
                    pdffileName: fileRecord.filename,
                    pdffilePath: fileRecord.path,
                })
                .where("ifabricId = :ifabricId", { ifabricId: fabricId })
                .execute();

            // console.log(`Update result for fabricId ${fabricId}:`, updateFilePath);

            if (updateFilePath.affected === 0) {
                // console.error(`Update failed for fabricId: ${fabricId}`);
                updateSuccess = false;
                continue;
            }
        }

        if (updateSuccess) {
            await manager.completeTransaction();
            return new UploadResponse(true, 11, 'Uploaded successfully', filePaths);
        } else {
            await manager.releaseTransaction();
            return new UploadResponse(false, 11, 'Some updates failed', filePaths);
        }
    } catch (error) {
        console.error('Error during PDF upload:', error);
        await manager.releaseTransaction();
        return new UploadResponse(false, 11, 'Upload failed due to error', filePaths);
    }
}

async excelUpload(filePaths:any[],fabIds:string):Promise<UploadResponse>{
    let parsedData;
    try{
        parsedData = JSON.parse(fabIds);
        console.log('Parsed Data:', parsedData);
    }catch(error){
        console.error('Error parsing fabIds:', error);
        return new UploadResponse(false, 11, 'Invalid fabIds format', []); 
    }
    const manager = new GenericTransactionManager(this.dataSource);
    try{
        await manager.startTransaction();
        let updateSuccess = true;
        for (const [index, value ] of parsedData.entries()){
            const fabricId = value.ifabricId;
            const fileRecord=filePaths[index];

            if(!fabricId || !fileRecord){
                updateSuccess= false;
                continue;
            }
            const updateFilePath = await manager.getRepository(IndentFabricEntity).createQueryBuilder().update(IndentFabricEntity).set({excelfilePath:fileRecord.path, excelfileName:fileRecord.filename}).where("ifabricId =:ifabricId",{ifabricId:fabricId}).execute();
            if(updateFilePath.affected === 0){
                updateSuccess=false;
                continue;
            }
        }
        if(updateSuccess){
            await manager.completeTransaction();
            return new UploadResponse(true,11,'Uploaded successfully',filePaths);
        }else{
            await manager.releaseTransaction();
            return new UploadResponse(false, 11, 'Some updates failed', filePaths);
        }
    }catch (error){
        console.error('Error during PDF upload:', error);
        await manager.releaseTransaction();
        return new UploadResponse(false, 11, 'Upload failed due to error', filePaths);  
    }
}

async PdfTrimUpload(filePaths: any[], fabIds: string): Promise<UploadResponse> {
    // console.log('Received file paths:', filePaths);
    // console.log('Received fabIds:', fabIds);

    let parsedData;
    try {
        parsedData = JSON.parse(fabIds);
        console.log('Parsed Data:', parsedData);
    } catch (error) {
        console.error('Error parsing fabIds:', error);
        return new UploadResponse(false, 11, 'Invalid fabIds format', []);
    }

    const manager = new GenericTransactionManager(this.dataSource);
    try {
        await manager.startTransaction();
        let updateSuccess = true;

        for (const [index, value] of parsedData.entries()) {
            const trimId = value.itrimsId;
            const fileRecord = filePaths[index];

            if (!trimId || !fileRecord) {
                // console.error(`Missing fabricId or file at index ${index}`);
                updateSuccess = false;
                continue;
            }

            // console.log(`Updating fabricId: ${fabricId} with file: ${fileRecord.filename}`);

            // Verify if the record exists
            const existingRecord = await manager.getRepository(IndentTrimsEntity).findOne({
                where: { itrimsId:trimId  },
            });

            if (!existingRecord) {
                // console.error(`No record found for ifabricId: ${fabricId}`);
                updateSuccess = false;
                continue;
            }

            const updateFilePath = await manager.getRepository(IndentTrimsEntity)
                .createQueryBuilder()
                .update(IndentTrimsEntity)
                .set({
                    pdffileName: fileRecord.filename,
                    pdffilePath: fileRecord.path,
                })
                .where("itrimsId = :itrimsId", { itrimsId: trimId })
                .execute();

            // console.log(`Update result for fabricId ${fabricId}:`, updateFilePath);

            if (updateFilePath.affected === 0) {
                // console.error(`Update failed for fabricId: ${fabricId}`);
                updateSuccess = false;
                continue;
            }
        }

        if (updateSuccess) {
            await manager.completeTransaction();
            return new UploadResponse(true, 11, 'Uploaded successfully', filePaths);
        } else {
            await manager.releaseTransaction();
            return new UploadResponse(false, 11, 'Some updates failed', filePaths);
        }
    } catch (error) {
        console.error('Error during PDF upload:', error);
        await manager.releaseTransaction();
        return new UploadResponse(false, 11, 'Upload failed due to error', filePaths);
    }
}

async excelTrimUpload(filePaths:any[],fabIds:string):Promise<UploadResponse>{
    let parsedData;
    try{
        parsedData = JSON.parse(fabIds);
        console.log('Parsed Data:', parsedData);
    }catch(error){
        console.error('Error parsing fabIds:', error);
        return new UploadResponse(false, 11, 'Invalid fabIds format', []); 
    }
    const manager = new GenericTransactionManager(this.dataSource);
    try{
        await manager.startTransaction();
        let updateSuccess = true;
        for (const [index, value ] of parsedData.entries()){
            const trimId = value.itrimsId;
            const fileRecord=filePaths[index];

            if(!trimId || !fileRecord){
                updateSuccess= false;
                continue;
            }
            const updateFilePath = await manager.getRepository(IndentTrimsEntity).createQueryBuilder().update(IndentTrimsEntity).set({excelfilePath:fileRecord.path, excelfileName:fileRecord.filename}).where("itrimsId =:itrimsId",{itrimsId:trimId}).execute();
            if(updateFilePath.affected === 0){
                updateSuccess=false;
                continue;
            }
        }
        if(updateSuccess){
            await manager.completeTransaction();
            return new UploadResponse(true,11,'Uploaded successfully',filePaths);
        }else{
            await manager.releaseTransaction();
            return new UploadResponse(false, 11, 'Some updates failed', filePaths);
        }
    }catch (error){
        console.error('Error during PDF upload:', error);
        await manager.releaseTransaction();
        return new UploadResponse(false, 11, 'Upload failed due to error', filePaths);  
    }
}
}



